/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryManagerValidationData
 */
export interface AncillaryManagerValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryManagerValidationData
     */
    ancillaryCategory?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryManagerValidationData
     */
    ancillaryName?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryManagerValidationData
     */
    weight?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AncillaryManagerValidationData
     */
    duplicates?: ValidationMessage;
}

export function AncillaryManagerValidationDataFromJSON(json: any): AncillaryManagerValidationData {
    return AncillaryManagerValidationDataFromJSONTyped(json, false);
}

export function AncillaryManagerValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryManagerValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : ValidationMessageFromJSON(json['ancillaryCategory']),
        'ancillaryName': !exists(json, 'ancillaryName') ? undefined : ValidationMessageFromJSON(json['ancillaryName']),
        'weight': !exists(json, 'weight') ? undefined : ValidationMessageFromJSON(json['weight']),
        'duplicates': !exists(json, 'duplicates') ? undefined : ValidationMessageFromJSON(json['duplicates']),
    };
}

export function AncillaryManagerValidationDataToJSON(value?: AncillaryManagerValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ancillaryCategory': ValidationMessageToJSON(value.ancillaryCategory),
        'ancillaryName': ValidationMessageToJSON(value.ancillaryName),
        'weight': ValidationMessageToJSON(value.weight),
        'duplicates': ValidationMessageToJSON(value.duplicates),
    };
}


